module.exports = __webpack_public_path__ + "static/assets/ea3dcbaa192a5d3412046e544d7fbf78.png";